// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"app-components-staticpages-blocks-centeredtextblock--text"};